import Request from '@hotmart-org-ca/request'

import Settings from 'common/helpers/settings/.'

const options = {
  headers: {
    application: 'Webinar'
  }
}

Request.register(
  `${Settings.api.live}/v1`,
  {
    get: {
      'get.schedule': '/schedule/:code',
      'get.schedule.public': '/public/schedule/:code',
      'get.schedule.private': '/schedule/:code/private',
      'get.schedule.private.hotmart': '/schedule/:code/private/hotmart',
      'get.schedule.info': '/public/schedule/:code/info',
      'get.schedule.feedback': '/public/schedule/feedback/:leadCode/:scheduleCode',
      'get.schedule.next': '/schedule/:code/next',
      'get.config': '/public/schedule/:code/config',
      'get.onfire.languages': '/schedule/onfire/:code/languages'
    },
    post: {
      'post.schedule.feedback': '/public/schedule/feedback'
    }
  },
  options
)
